module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres7fe"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "unLoadBool": true,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHres7feIndex,
      "editEvent": _vm.editEvent,
      "searchBoxAlias": "hres7fe"
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "searchIndex": _vm.searchIndex,
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "indexSelected": _vm.indexSelected,
      "detail": _vm.detail,
      "codeval": _vm.codempid,
      "receivedHres7feDetail": _vm.receivedHres7feDetail,
      "descCodeval": _vm.app.currentUser.username[_vm.app.nowLang],
      "postHres7feTab1Save": _vm.postHres7feTab1Save,
      "postHres7feTab2Save": _vm.postHres7feTab2Save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43ca0305!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7fe/component.vue
// module id = 3719
// module chunks = 1